export default "__VITE_PUBLIC_ASSET__25ed6e3c__"